import Api from '../../api'
import { call, put, takeLatest } from 'redux-saga/effects'
import { delay } from 'redux-saga'
import {
  CHANGE_USER_ACCOUNT,
  LOGOUT,
} from 'portal-modules/auth/redux/modules/user'
import createRequestSaga from '../create-request-saga'

// action types
export const REQUEST_BALANCE_DETAILS = 'rp/balance/REQUEST_BALANCE_DETAILS'
export const RECEIVE_BALANCE_DETAILS = 'rp/balance/RECEIVE_BALANCE_DETAILS'
export const RESET_BALANCE_DETAILS = 'rp/balance/RESET_BALANCE_DETAILS'

// action creators
export const requestBalanceDetails = (payload, callback = () => {}) => ({
  type: REQUEST_BALANCE_DETAILS,
  payload,
  callback,
})

export const receiveBalanceDetails = payload => ({
  type: RECEIVE_BALANCE_DETAILS,
  payload,
})

export const resetBalanceDetails = () => ({ type: RESET_BALANCE_DETAILS })

// reducer
export default (state = {}, { payload, type }) => {
  switch (type) {
    case RECEIVE_BALANCE_DETAILS:
      return { ...state, ...payload }
    case CHANGE_USER_ACCOUNT:
    case RESET_BALANCE_DETAILS:
      return {}
    case LOGOUT:
      return {}
    default:
      return state
  }
}

// sagas
export function* fetchBalanceDetails({ payload, callback }) {
  yield delay(1200)
  let API_BALANCE_DETAILS = Api.getLeaseBalanceDetails
  let API_PAYLOAD = { lease_id: payload }
  if (window.rpSettings.projectName == 'rh') {
    API_BALANCE_DETAILS = Api.getContractBalanceDetails
    API_PAYLOAD = { contract_id: payload }
  }
  const data = yield call(API_BALANCE_DETAILS, API_PAYLOAD)
  yield put(receiveBalanceDetails(data))
  if (typeof callback === 'function') {
    yield callback()
  }
}

export function* watchRequestBalanceDetails() {
  yield takeLatest(
    REQUEST_BALANCE_DETAILS,
    createRequestSaga(fetchBalanceDetails, {
      key: 'balanceDetails',
      message: __('Checking for balance details'),
    }),
  )
}

export const sagas = [watchRequestBalanceDetails]
